<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>

<div *ngIf="!enableLoader" #quotesPage class="filter-nav overflow-visible border-bottom bg-light py-2">
  <div class="container visible-xs-filter-bar w-100">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center ">
        <div class="strong  text-nowrap">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
      <div class="ml-2">
        <ng-select [items]="shiplocations" [multiple]="true" [clearable]="false" bindLabel="name"
          dropdownPosition="bottom" groupBy="code" [selectableGroup]="true"
          placeholder="Select location" [(ngModel)]="selectedLocation"
          [closeOnSelect]="true" bindValue="code" notFoundText="{{'heading.NoItemsFound' | cxTranslate }}"
          (change)="filterData()">
          <ng-template ng-multi-label-tmp>
            <span class="filter-count pl-2 text-black">{{selectedLocation?.length}}x
              Locations Selected</span>
          </ng-template>
          <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
            class="dropdown-ng-template">
            <!-- <input type="checkbox" /> -->
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <div>
              <input id="{{item.code}}" [ngModel]="item$.selected" [checked]="item.checked" type="checkbox" />
              <span>{{item.name}}</span>
            </div>
          </ng-template>
        </ng-select>
      </div>
        <div class="ml-2">
          <ng-select [items]="commodityData" [multiple]="true" [clearable]="false" bindLabel="description"
            dropdownPosition="bottom" groupBy="id" [selectableGroup]="true"
            placeholder="{{ 'home.productHeader.SelectCommodity' | cxTranslate }}" [(ngModel)]="selectedCommodity"
            [closeOnSelect]="true" bindValue="id" notFoundText="{{'heading.NoItemsFound' | cxTranslate }}"
            (change)="filterData()">
            <ng-template ng-multi-label-tmp>
              <span class="filter-count pl-2 text-black">{{selectedCommodity?.length}}x
                {{'home.productHeader.SelectedCommodity' | cxTranslate }}</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
              class="dropdown-ng-template">
              <!-- <input type="checkbox" /> -->
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div>
                <input id="{{item.id}}" [ngModel]="item$.selected" [checked]="item.checked" type="checkbox" />
                <span>{{item.description}}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>
        <div class="ml-2">
          <ng-select [items]="materialList" [multiple]="true" [clearable]="false" bindLabel="name"
            dropdownPosition="bottom" groupBy="code" [selectableGroup]="true"
            placeholder="{{ 'home.productHeader.SelectProducts' | cxTranslate }}" [(ngModel)]="selectedProduct"
            [closeOnSelect]="true" bindValue="code" notFoundText="{{'heading.NoItemsFound' | cxTranslate }}"
            (change)="filterData()">
            <ng-template ng-multi-label-tmp>
              <span class="filter-count pl-2 text-black">{{selectedProduct?.length}}x
                {{'home.productHeader.SelectedProductsTypes' | cxTranslate }}</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
              class="dropdown-ng-template">
              <!-- <input type="checkbox" /> -->
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div>
                <input id="{{item.code}}" [ngModel]="item$.selected" [checked]="item.checked" type="checkbox" />
                <span>{{item.name}}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>
        <div class="ml-1 picker">
          <input name="datepicker" placeholder="{{ 'home.contracts.dateRange' | cxTranslate }}"
            class="form-control mobile ml-2 mt-3 filter-bar-input" ngbDatepicker #datepicker="ngbDatepicker"
            [autoClose]="'outside'" (dateSelect)="onDateSelection($event,datepicker)"
            [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''"
            [displayMonths]="2" [dayTemplate]="t" [footerTemplate]="footerTemplate" autocomplete="off"
            outsideDays="visible" [startDate]="startDate!" (click)="toggle(datepicker)">
          <ng-template #t let-date let-focused="focused">
            <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
              {{ date.day }}
            </span>
          </ng-template>
          <ng-template #footerTemplate>
            <hr class="my-0">
            <button class="btn btn-primary btn-sm m-2 float-left" (click)="resetCalendar(datepicker)">{{
              'home.contracts.Reset' | cxTranslate }}</button>
            <button class="btn btn-secondary btn-sm m-2 float-right" (click)="datepicker.close()">{{ 'home.quote.Close'
              | cxTranslate }}</button>
          </ng-template>
        </div>
        <div *ngIf="showClear" class="ml-3 mr-2">
              <button type="button" class="btn btn-warning clear-text height" (click)="clearFilterData()">
                {{'home.productHeader.ClearFilter' | cxTranslate }}</button>
            </div> 
      </div>
      <!-- Search functionality for desktop -->
      <div class="d-flex align-items-center mr-2 search-section-col">
        <div class="search-section-div">
          <div class="input-group d-flex align-items-center">
            <input class="form-control form-control-lg border rounded-pill input-field" type="search"
              (keypress)="omit_special_char($event)" [(ngModel)]="searchText" (input)="search()"
              placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
            <span class="input-group-append">
              <button name='searchbuttondesktop'
                class="btn btn-outline-secondary btnUpgrade rounded-pill border-0 input-field bg-white border-start-0 border-bottom-0 border ms-n5"
                type="button">
                <i class="fa fa-search pe-none"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Search functionality for mobile -->
  <div class="container hidden-xs-filter-bar">
    <div class="row">
      <div class="w-100">
        <div class="filter-select-div-mobile pl-4">
          <div class="input-group p-2">
            <input class="form-control form-control-lg border rounded-pill input-field" type="search"
              (keypress)="omit_special_char($event)" [(ngModel)]="searchText" (input)="search()"
              placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
            <span class="input-group-append">
              <button name='searchbuttonfilter' class="
                            btn
                            rounded-pill
                            border-0
                            input-field
                            border-start-0 border-bottom-0 border
                            ms-n5
                          " type="button">
                <i class="fa fa-search mobbar"></i>
              </button>
              <div class='hidden-xs-filter-bar vertical ml-4'></div>
              <div class='hidden-xs-filter-bar pr-2 pl-4' (click)='filtersidebar()'>
                <img class="ml-1" src="./images/filternew.svg"><sup class="pl-2 pr-2 pt-1 pb-1"
                  *ngIf='length'>{{length}}</sup>
                <div class="ff-semibold fs-10 d-flex align-items-center text-black Filternew">{{ 'home.filter.filters' |
                  cxTranslate }}</div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="background">
      <div [ngClass]="sidebar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' "
        class="hidden-xs-filter-bar sidebar">
        <div class=' d-flex justify-content-between p-3 border sticky'>
          <div class="fs-24 strong pl-1">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
          <div (click)="closebar()"><img src="/images/sidebarcross.svg" alt="">
          </div>
        </div>
        <div class="d-flex strong  pl-3 pt-3 pb-2">Locations</div>
        <div *ngFor="let item of shiplocations" class="ml-5  d-flex line-height">
          <label class="ff-normal">
            <input type="checkbox" [(ngModel)]="item.selected" [value]="item.code" [checked]="item.selected"
              (change)="onCheckboxlocationChange($event , item.code)" />
            {{item.name}}
          </label>
        </div>
        <div>
          <div class="d-flex strong  pl-3 pt-3 pb-2">{{ 'home.contracts.date' | cxTranslate }}:</div>
          <form role="form" class="date-range-picker-form ml-4">
            <div class="form-group pr-3 mb-1">
              <div class="input-group">
                <div class="input-group-prepend">

                  <input name="datepicker" class="form-control form-control-lg filter-mob"
                    placeholder="{{'home.contracts.selectdaterange' | cxTranslate }}" ngbDatepicker
                    #datepicker1="ngbDatepicker" [autoClose]="'outside'"
                    (dateSelect)="onDateSelection($event,datepicker1)"
                    [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''"
                    [displayMonths]="2" [dayTemplate]="t" [footerTemplate]="footer" autocomplete="off"
                    outsideDays="visible" [startDate]="startDate!" (click)="toggle(datepicker1)"
                    placeholder="{{ 'home.contracts.dateRange' | cxTranslate }}">
                  <ng-template #t let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                      [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                      (mouseleave)="hoveredDate = null">
                      {{ date.day }}
                    </span>
                  </ng-template>
                  <ng-template #footer>
                    <button class="btn btn-primary btn-sm m-2 float-left" (click)="resetCalendar(datepicker1)">{{
                      'home.contracts.Reset' | cxTranslate }}</button>
                    <button class="btn btn-secondary btn-sm m-2 float-right" (click)="datepicker1.close()">{{
                      'home.quote.Close' | cxTranslate }}</button>
                  </ng-template>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="d-flex strong  pl-3 pt-3 pb-2">{{ 'home.filter.products' | cxTranslate }}</div>
        <div *ngFor="let item of materialList" class="ml-5  d-flex line-height">
          <label class="ff-normal">
            <input type="checkbox" [(ngModel)]="item.selected" [value]="item.code" [checked]="item.selected"
              (change)="onCheckboxproductChange($event , item.code)" />
            {{item.name}}
          </label>
        </div>
        <div class="d-flex md-semibold-font  pl-3 pt-3 pb-2">{{ 'home.filter.commodityType' | cxTranslate }}</div>
        <div *ngFor="let item of commodityData; let i=index" class=" ml-5  d-flex line-height ">
          <label class="scroll-checkbox">
            <input type="checkbox" [(ngModel)]="item.selected" [value]="item.id" [checked]="item.selected"
              (change)="onCheckboxCommodityChange($event , item.id)" />
            {{item.description }}
          </label>
        </div>
        <div class="sticky-bottom p-4 border-top">
          <button class="btn btn-block btn-primary w-100" (click)="getResults()">{{ 'home.contracts.seeResults'|
            cxTranslate}}</button>
          <button class='btn btn-block' (click)="clearFilterMobile($event)">{{ 'home.contracts.clearFilter' |
            cxTranslate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="py-3">
  <div class="container">
    <nav class="project-tab">
      <div *ngIf="!enableLoader" class="nav nav-tabs nav-fill d-flex" id="nav-tab" role="tablist">
        <div><a class="nav-item nav-link text-dark nav-align active strong" [class.active]="quotesTab === 'active'"
            id="nav-active-tab" data-toggle="tab" href="#nav-by-active" role="tab" aria-controls="nav-home"
            aria-selected="true" (click)="changeTab('active')">{{ 'home.quote.Active' | cxTranslate }}
          </a></div>
        <div><a class="nav-item nav-link text-dark nav-align d-inline-flex strong"
            [class.active]="quotesTab === 'completed'" id="nav-accepted-tab" data-toggle="tab" href="#nav-by-completed"
            role="tab" aria-controls="nav-profile" aria-selected="false" (click)="changeTab('completed')">{{
            'home.quote.Accepted' | cxTranslate }}
            <span *ngIf="acceptCount!=0"
              class="display-6 d-flex tex-center text-success bg-white ml-1 border-radius-1 pl-1 pr-1">{{acceptCount}}
              {{ 'home.quote.Today' | cxTranslate }}</span></a></div>
        <div><a class="nav-item nav-link text-dark nav-align strong" [class.active]="quotesTab === 'archived'"
            id="nav-archived-tab" data-toggle="tab" href="#nav-by-completed" role="tab" aria-controls="nav-profile"
            aria-selected="false" (click)="changeTab('archived')">{{'home.quote.Archived' | cxTranslate }} </a>
        </div>
      </div>
    </nav>
    <!-- <div class="visible-xs d-flex desktop-mt-3"> -->
    <!-- <span *ngIf='activeTab != "active"' class="small visible-xs mr-4 mt-2 col-3">{{ 'home.quote.Creation' | cxTranslate }}
        </span> -->
    <!-- <div class="input-group hidden mr-2 col-7 col-md-12 col-lg-4" *ngIf='activeTab != "active"'>
            
            <input name="datepicker"   placeholder="{{'home.contracts.selectdaterange' | cxTranslate }}" class="form-control form-control-lg picker" ngbDatepicker #datepicker="ngbDatepicker" [autoClose]="disabled"
                (dateSelect)="onDateSelection($event,datepicker)" 
                [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''" [displayMonths]="2" [dayTemplate]="t"
                [footerTemplate]="footerTemplate" outsideDays="hidden" [startDate]="startDate!" (click)="toggle(datepicker)" autocomplete="off">
            <ng-template #t let-date let-focused="focused">
                <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                    [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null">
                    {{ date.day }}
                </span>
            </ng-template>
            <ng-template #footerTemplate>
                <hr class="my-0">
                <button class="btn btn-primary btn-sm m-2 float-left" (click)="resetCalendar(datepicker)">{{ 'home.contracts.Reset' | cxTranslate }}</button>
                <button class="btn btn-secondary btn-sm m-2 float-right" (click)="datepicker.close()">{{ 'home.quote.Close' | cxTranslate }}</button>
            </ng-template>
        </div> -->
    <!-- <div class="visible-xs">
                    <div class="input-group">
                        <input class="form-control form-control-lg border-radius-30 bg-white" [(ngModel)]="searchInput" (input)="searchQuote(searchInput)" type="search" placeholder="{{'home.contracts.SearchID' | cxTranslate }}" (keypress)="omitSpecialChar($event)" preventCutCopyPaste/>
                        <span class="input-group-append">
              <button name='searchbutton' class=" btn rounded-pill border-0 btn-height border-start-0 border-bottom-0 border ms-n5 "
                type="button">
                <i class="fa fa-search pe-none"></i>
              </button>
            </span>
                    </div>
                </div> -->
    <!-- </div> -->
  </div>
</div>
<div *ngIf="enableLoader" id="loader"></div>
<div class="container py-3 mob">
  <div class="alert alert-success" *ngIf="showPlacedBidmsg">
    <div><span class=" text-success pl-3" *ngIf="showPlacedBidmsg">
        {{ 'home.quote.bidPlacedSuccess' | cxTranslate }}</span>
    </div>
    <button class="btn" (click)="clear()"><i class="fa fa-times text-success" aria-hidden="true"></i></button>
  </div>
  <div class="alert alert-success" *ngIf="showAcceptedMsg">
    <div><span class=" text-success pl-3" *ngIf="showAcceptedMsg">
        {{ 'home.quote.Congratulations' | cxTranslate }}</span>
    </div>
    <button class="btn" (click)="clear()"><i class="fa fa-times text-success" aria-hidden="true"></i></button>
  </div>
  <div class="alert alert-danger" *ngIf="showCancelledMsg || showRejectedMsg">
    <div>
      <span *ngIf="showCancelledMsg && (!orders || orders?.length === 0)" class="text-danger pl-3">{{ 'home.quote.cancelledBid' | cxTranslate }}</span>
      <span *ngIf="showCancelledMsg && orders?.length > 0" class="text-danger pl-3">Your order is cancelled</span>
      <span *ngIf="showRejectedMsg && (!orders || orders?.length === 0)" class="text-danger pl-3">{{ 'home.quote.rejectBid' | cxTranslate }}</span>
      <span *ngIf="showRejectedMsg && orders?.length > 0" class="text-danger pl-3">Your order has been rejected</span>

    </div>
    <button class="btn" (click)="clear()"><i class="fa fa-times text-danger" aria-hidden="true"></i></button>
  </div>
  <div *ngIf="!enableLoader">
<div *ngIf="noBids"
  class="text-center strong  text-secondary mb-5">{{'tenders.noBids'| cxTranslate}}</div>
    <div *ngIf="!enableLoader && OpenNegotiation===true">
      <div> <span class="h3 strong mb-4"
          *ngIf="tenderQuotesListData?.length>0 && !enableLoader">{{'tenders.invitationToBid'| cxTranslate}}</span>
        <!-- <div *ngIf="tenderQuotesListData?.length == 0 && !enableLoader" class="text-center strong  text-secondary mb-5">{{ 'home.quote.currently' | cxTranslate }}</div>  -->
        <div class="card pt-3 pb-3 px-4 my-4 card-border border-radius-05"
          *ngFor="let data of tenderQuotesListData,let i=index">
          <div class=" border-bottom pb-2">
            <div class="d-none d-lg-block">
              <div class="d-flex justify-content-between">
                <div class='d-flex align-items-center '>
                  <div class="bid-status-text p-1 badge badge-secondary" *ngIf="data.quoteState=='BID_PLACED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-light" *ngIf="data.quoteState=='CANCELLED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-light" *ngIf="data.quoteState=='BID_EXPIRED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-light" *ngIf="data.quoteState=='REJECTED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-primary" *ngIf="data.quoteState=='OFFER_RECEIVED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-success" *ngIf="data.quoteState=='ACCEPTED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-light" *ngIf="data.quoteState=='OFFER_EXPIRED'">
                    {{data.quoteStatus}}</div>
                  <div class="small text-secondary ml-3 visible-xs"
                    *ngIf="activeTab === 'active' && data.quoteState!='OFFER_RECEIVED'"> {{ 'home.quote.validity' |
                    cxTranslate }} {{convertDate(data ?.quoteValidity,data.quoteValidityTimeZone)}}
                    {{data.quoteValidityTimeZone?data.quoteValidityTimeZone.code:''}}</div>
                  <div class="ml-4 mt-0 text-danger  small"
                    *ngIf="activeTab === 'active' && data.quoteState!='OFFER_RECEIVED'">{{expiryCalculate(data
                    ?.quoteValidity)}}</div>
                  <div class="small text-secondary ml-3 visible-xs"
                    *ngIf="activeTab === 'active' && data.quoteState=='OFFER_RECEIVED'"> {{ 'home.quote.validity' |
                    cxTranslate }} {{convertDate(data ?.offerValidity,data.offerValidityTimeZone)}}
                    {{data.offerValidityTimeZone?data.offerValidityTimeZone.code:''}}</div>
                  <div class="ml-4 mt-0 text-danger  small"
                    *ngIf="activeTab === 'active' && data.quoteState=='OFFER_RECEIVED'">{{expiryCalculate(data
                    ?.offerValidity)}}</div>
                </div>
                <div class='d-flex '>
                  <div class="small text-secondary  mr-3">{{ 'home.quote.Id' | cxTranslate }}
                    {{data.c4cQuoteExternalQuoteId ? data.c4cQuoteExternalQuoteId:'--'}}</div>
                  <div class="small text-secondary mr-3">{{ 'home.quote.Creationdate' | cxTranslate
                    }}{{convertingDateOnly(data ?.creationTime)}}</div>
                  <div class="small text-secondary ">{{'home.quote.BidPlacedBy' | cxTranslate }}: {{data.userName}}
                  </div>
                </div>
              </div>

            </div>
            <div class="d-lg-none ">
              <div class='card-header bg-white p-0 border-0 d-flex flex-row justify-content-between'>
                <div>
                  <div class="bid-status-text p-1 badge badge-secondary" *ngIf="data.quoteState=='BID_PLACED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-light" *ngIf="data.quoteState=='CANCELLED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-light" *ngIf="data.quoteState=='BID_EXPIRED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-light" *ngIf="data.quoteState=='REJECTED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-primary" *ngIf="data.quoteState=='OFFER_RECEIVED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-success" *ngIf="data.quoteState=='ACCEPTED'">
                    {{data.quoteStatus}}</div>
                  <div class="bid-status-text p-1 badge badge-light" *ngIf="data.quoteState=='OFFER_EXPIRED'">
                    {{data.quoteStatus}}</div>
                </div>
                <div>
                  <div class="small text-secondary ml-3 "
                    *ngIf="activeTab === 'active' && data.quoteState!='OFFER_RECEIVED'"> {{ 'home.quote.validity' |
                    cxTranslate }} {{convertDate(data ?.quoteValidity,data.quoteValidityTimeZone)}}
                    {{data.quoteValidityTimeZone?data.quoteValidityTimeZone.code:''}}</div>
                  <div class="small text-secondary ml-3 "
                    *ngIf="activeTab === 'active' && data.quoteState=='OFFER_RECEIVED'"> {{ 'home.quote.validity' |
                    cxTranslate }} {{convertDate(data ?.offerValidity,data.offerValidityTimeZone)}}
                    {{data.offerValidityTimeZone?data.offerValidityTimeZone.code:''}}</div>
                </div>

              </div>
              <div class="">
                <div class=" mt-1 text-danger bold  small"
                  *ngIf="activeTab === 'active' && data.quoteState!='OFFER_RECEIVED'">{{expiryCalculate(data
                  ?.quoteValidity)}}</div>
                <div class=" mt-1 text-danger bold small"
                  *ngIf="activeTab === 'active' && data.quoteState=='OFFER_RECEIVED'">{{expiryCalculate(data
                  ?.offerValidity)}}</div>
              </div>
              <div class=''>
                <div class="small text-secondary  mr-3">{{ 'home.quote.Id' | cxTranslate }}
                  {{data.c4cQuoteExternalQuoteId ? data.c4cQuoteExternalQuoteId:'--'}}</div>
                <div class="small text-secondary mr-3">{{ 'home.quote.Creationdate' | cxTranslate
                  }}{{convertingDateOnly(data ?.creationTime)}}</div>
                <div class="small text-secondary ">{{'home.quote.BidPlacedBy' | cxTranslate }}: {{data.userName}}</div>
              </div>
            </div>
          </div>


          <!-- <div class="hr"></div> -->
          <div class="  align-self-stretch border-bottom"
            *ngFor="let quote of tenderQuotesListData[i].combinedTenders; let j=index">
            <div class="row">
              <div class="col py-3">
                <div class="small text-secondary  small" *ngIf="tenderQuotesListData[i].combinedTenders.length>1">{{
                  'home.headerLinks.material' | cxTranslate }} #{{j+1}}</div>
                <div class="h5 mb-0 fw-bold">{{quote.newName?quote.newName:quote.productName}}</div>
                <div *ngIf="tenderQuotesListData[i].commodityType!='CN'">
                  <div class="mb-0 lg-font mb-0 text-secondary " *ngFor="let row of quote?.pricingOptionsEnum">
                    {{row.pricingOptionsValue}}</div>
                </div>

              </div>
              <div *ngIf="quote?.pricingOptionsEnum" class='col-12 col-md-8 py-2 py-md-3 d-flex flex-wrap justify-content-start justify-content-md-end'>
                <ng-container *ngFor="let options of quote.pricingOptionsEnum">
                  <div
                    *ngIf="tenderQuotesListData[i].commodityType !='CN' && options.pricingOptions!='FLOATING_PREMIUM' && quote.set==''"
                    class="col-6 col-md-auto pl-0 pl-md-3 list-col-data mb-2 mb-md-0">
                    <div class="small text-secondary">
                      {{getLabelofConfirmScreen(options,tenderQuotesListData[i].commodityType,'ITB')}}</div>
                    <div class="strong mb-2"> {{getPriceandSymbol(options,quote,tenderQuotesListData[i].commodityType)}}
                    </div>
                  </div>
                  <ng-container *ngIf="tenderQuotesListData[i].commodityType =='CN' ">
                    <div class="col-6 col-md-auto pl-0 pl-md-3 list-col-data mb-2 mb-md-0">
                      <div class="small text-secondary">TC (per {{options.tcPriceUnitDesc}})</div>
                      <div class="strong mb-2">USD {{quote?.tcPrice?.value }} </div>
                    </div>
                    <div class="col-6 col-md-auto pl-0 pl-md-3 list-col-data mb-2 mb-md-0" *ngIf="options.displayRCPrice== true">
                      <div class="small text-secondary">RC (per {{options.rcPriceUnitDesc}} of payable Copper)
                      </div>
                      <div class="strong mb-2">USD {{quote?.rcPrice?.value}} </div>
                    </div>
                  </ng-container>
                  <div class="col-6 col-md-auto pl-0 pl-md-3 list-col-data mb-2 mb-md-0">
                    <div class="small text-secondary">{{ 'tenders.Quantity(DMT)' | cxTranslate
                      }}({{quote.displayQuantityUnitDesc}})</div>
                    <div class="strong mb-2">{{quote.quantity | number}}</div>
                  </div>
                  <div class="col-6 col-md-auto pl-0 pl-md-3 mb-2 mb-md-0">
                    <div class="small text-secondary" *ngIf="data.commodityType=='CN' && data.arrivalPeriod == 'false'">
                      {{'tenders.Deliveryperiod'| cxTranslate}}</div>
                    <div class="small text-secondary" *ngIf=" data.arrivalPeriod == 'true'">{{'tenders.ArrivalPeriod'|
                      cxTranslate}}
                    </div>
                    <div class="small text-secondary"
                      *ngIf="(data.commodityType=='CC' ||data.commodityType=='IO') && data.arrivalPeriod == 'false'">
                      {{'tenders.LoadPortLaycan'| cxTranslate}} </div>
                    <div class="small text-secondary"
                      *ngIf="(data.commodityType=='CA') && data.arrivalPeriod == 'false'">
                      {{'tenders.schedule'| cxTranslate}} </div>
                    <div class="strong mb-2" *ngIf=" data.arrivalPeriod == 'false'">{{quote.laycanStartDate |
                      date:"dd/MM/yyyy"}}
                      - {{quote.laycanEndDate | date:"dd/MM/yyyy"}}</div>
                    <div class="strong mb-2" *ngIf=" data.arrivalPeriod == 'true'">{{data.arrivalStartDate |
                      date:"dd/MM/yyyy"}} -
                      {{data.arrivalEndDate | date:"dd/MM/yyyy"}}</div>
                  </div>
                </ng-container>
                <!-- <div class="d-none d-sm-block ml-3 list-col-data"
                                    *ngIf="quote?.pricingOptionsEnum[0]?.pricingOptions=='FIXED_PRICE' && !quote?.tcPrice && !quote?.rcPrice">
                                    <div *ngIf="tenderQuotesListData[i].commodityType !='CC' ||quote.set==''" class="small text-secondary">Price (per
                                      {{quote.displayFixedPriceConfig.displayFixedPriceUnitDesc}})</div>
                                    <div *ngIf="tenderQuotesListData[i].commodityType !='CC' ||quote.set==''" class="strong mb-2">USD
                                      {{quote?.relativePrice?.value}} </div>
                                    
                                  </div>
                                  <div class="d-none d-sm-block ml-3 list-col-data"
                                    *ngIf="(quote?.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE'|| quote.pricingOptionsEnum[0].pricingOptions=='LUMP_FIXED_PRICE') && !quote?.tcPrice && !quote?.rcPrice">
                                    <div *ngIf="quote?.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE' && data.commodityType!='CC'"
                                      class="small text-secondary">Premium/discount (per {{quote.displayIndexPriceConfig.displayIndexPriceUnitDesc}})
                                    </div>
                                    <div *ngIf="quote?.pricingOptionsEnum[0]?.pricingOptions=='LUMP_FIXED_PRICE' && data.commodityType!='CC'"
                                      class="small text-secondary">Premium/discount (per
                                      {{quote.displayLumpFixedPriceConfig.displayLumpFixedPriceUnitDesc}})</div>
                                    <div *ngIf="quote?.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE' && data.commodityType=='CC' && quote.set==''"
                                      class="small text-secondary">Price </div>
                                    <div *ngIf="quote?.pricingOptionsEnum[0]?.pricingOptions=='LUMP_FIXED_PRICE' && data.commodityType=='CC'"
                                      class="small text-secondary">Price (per {{quote.displayLumpFixedPriceConfig.displayLumpFixedPriceUnitDesc}})</div>
                                  
                                    <div *ngIf="data.commodityType!='CC'" class="strong mb-2">USD {{quote?.premiumDiscount?.value|| '0'}} </div>
                                    <div *ngIf="data.commodityType=='CC' && quote.set==''" class="strong mb-2"> {{quote?.premiumDiscount?.value}} %</div>
                                  </div>
                                  
                                 
                                  <!-- <div class="d-block d-sm-none w-100"
                                    *ngIf="quote?.pricingOptionsEnum[0]?.pricingOptions=='FIXED_PRICE' && data.commodityType!='CN'">
                                    <div class=" small text-secondary">Price (per {{quote.displayFixedPriceUnitDesc}})</div>
                                    <div class="strong mb-2"> USD {{quote?.relativePrice?.value}} </div>
                                  </div>
                                  <div class="d-block d-sm-none w-100"
                                    *ngIf="(quote?.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE' || quote.pricingOptionsEnum[0].pricingOptions=='LUMP_FIXED_PRICE')&& data.commodityType!='CN'">
                                    <div *ngIf="quote?.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE' && data.commodityType!='CC'"
                                      class="small text-secondary">Premium/discount (per {{quote.displayIndexPriceConfig.displayIndexPriceUnitDesc}})
                                    </div>
                                    <div *ngIf="quote?.pricingOptionsEnum[0]?.pricingOptions=='LUMP_FIXED_PRICE'&& data.commodityType!='CC'"
                                      class="small text-secondary">Premium/discount (per
                                      {{quote.displayLumpFixedPriceConfig.displayLumpFixedPriceUnitDesc}})</div>
                                    <div *ngIf="quote?.pricingOptionsEnum[0]?.pricingOptions=='INDEX_PRICE' && data.commodityType=='CC'"
                                      class="small text-secondary">Price</div>
                                    <div *ngIf="quote?.pricingOptionsEnum[0]?.pricingOptions=='LUMP_FIXED_PRICE' && data.commodityType=='CC'"
                                      class="small text-secondary">Price (per {{quote.displayLumpFixedPriceConfig.displayLumpFixedPriceUnitDesc}})</div>
                                  
                                    <div *ngIf="data.commodityType!='CC'" class="strong mb-2">USD {{quote?.premiumDiscount?.value || '0'}} </div>
                                    <div *ngIf="data.commodityType=='CC'" class="strong mb-2">{{quote?.premiumDiscount?.value}} %</div>
                                  </div>
                                  <div class="d-block d-sm-none mr-4 w-100" *ngIf="data.commodityType=='CN'">
                                    <div class=" small text-secondary">TC (per {{quote.displayTCPriceConfig.displayTCPriceUnitDesc}})</div>
                                    <div class="strong mb-2"> USD {{quote?.tcPrice?.value}} </div>
                                  </div>
                                  <div class="d-block d-sm-none mr-4 w-100"
                                    *ngIf="data.commodityType=='CN' && quote.displayRCPriceConfig.displayRCPrice == true">
                                    <div class=" small text-secondary">RC (per {{quote.displayRCPriceConfig.displayRCPriceUnitDesc}})</div>
                                    <div class="strong mb-2"> USD {{quote?.rcPrice?.value}} </div>
                                </div> -->
              </div>
            </div>
          </div>

          <div class="inside-layout  align-self-stretch pt-3">
            <div class="viewdetails ">
              <a class="strong  text-primary " (click)="openDetailsQuote(data)">
                {{ 'home.quote.Viewdetails' | cxTranslate }} ></a>
            </div>
            <div class="d-flex flex-column">
              <span class="mb-1"
                *ngIf="tenderQuotesListData[i].quoteStatus == 'Bid placed'&& tenderQuotesListData[i].editCancelBidDisplay==true && tenderQuotesListData[i].c4cQuoteExternalQuoteId">
                <button class="btn border pl-5 pr-5  w-100 " [disabled]="isPlaceBidDisabled" (click)="openmodal(i,'editbid')">
                  {{'tenders.EditBid'| cxTranslate}}</button></span>
              <!-- <span class="mr-3" *ngIf="quote?.tcPrice && quote?.rcPrice"> <button class="btn border pl-5 pr-5 mt-2 w-100 "
                                      (click)="metalOpenModal(i)">
                                      {{'tenders.EditBid'| cxTranslate}}</button></span> -->
              <!-- <span class="mr-3" *ngIf="tenderQuotesListData[i].quoteStatus == 'Bid placed'&& tenderQuotesListData[i].editCancelBidDisplay==true && tenderQuotesListData[i].commodityType ==''"> <button class="btn border pl-5 pr-5  w-100 "
                                      (click)="cancelmodal(i)">
                                      {{ 'home.quote.Cancelbid' | cxTranslate }}</button></span> -->
              <span class="mb-1" *ngIf="tenderQuotesListData[i].quoteStatus == 'Offer received'"> <button
                  class="btn border pl-5 pr-5  btn-primary btn-mobile-accept" [disabled]="isAcceptOfferDisabled" (click)="acceptbid(i)">
                  {{'home.quote.Acceptoffer' | cxTranslate }}</button></span>


              <!-- <div class="desktop-flex">
                          <span> <button class="btn border pl-5 pr-5 mt-2 w-100 "
                              (click)="openCancelModal(a)">
                              {{ 'home.quote.Cancelbid' | cxTranslate }}</button></span>
                          </div> -->
            </div>
            <!-- <div class="viewdetails d-block d-sm-none ">
                              <a class="strong  btn btn-link" (click)="openDetailsQuote(data)">
                {{ 'home.quote.Viewdetails' | cxTranslate }} ></a>
                          </div> -->
                        </div>
          </div>
        </div>
      </div>
   
    <div><span class="h3 strong mb-4"
        *ngIf="!noData && !enableLoader && quotesData?.length>0">{{'tenders.PortsideProducts'| cxTranslate}}</span>
      
      <div class="card pt-3 pb-3 px-4 my-4 card-border border-radius-05" *ngFor="let a of quotesData; let i = index">
        <!-- Desktop View -->
         <div class=" d-none d-md-block d-lg-block">
        <div class="d-flex justify-content-between">
          <div class='d-flex align-items-center'>
            <div class="bid-status-text p-1 badge badge-light" [ngClass]="a.quoteState|quoteStatusStyle">
              {{ a.quoteStatus }}</div>
            <div class="small text-secondary ml-3 visible-xs"
              *ngIf="activeTab === 'active' && a.quoteValidity != undefined "
                         [ngClass]="a.quoteState == quoteStatusModel.offerReceived?'visible-lg':''"> {{ 'home.quote.validity' |
              cxTranslate }} {{a.quoteState ==
              quoteStatusModel.offerReceived?convertDate(a.offerValidity):convertDate(a.quoteValidity)}}</div>
            <div *ngIf="a.quoteState == quoteStatusModel.offerReceived" class="ml-4 mt-0 text-danger  small">
              {{expiryCalculate(a.offerValidity)}}</div>
          </div>
          <div class='d-flex'>
            <span class="small text-secondary visible-xs mr-1">{{ 'home.quote.Id' | cxTranslate }} {{
              a.c4cQuoteExternalQuoteId ? a.c4cQuoteExternalQuoteId : ' '}}</span> &nbsp;
            <span class="small text-secondary visible-xs mr-3">
              {{ 'home.quote.Creationdate' | cxTranslate }} {{convertDateOnly(a.creationTime)}}
            </span>
            <span class="small text-secondary visible-xs">{{'home.quote.BidPlacedBy' | cxTranslate }}:
              {{a.userName}}</span>
              </div>
              </div>
              </div>
        <!-- Mobile View -->
        <div class="d-lg-none">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <div class="bid-status-text p-1 badge badge-light" [ngClass]="a.quoteState|quoteStatusStyle">
                {{ a.quoteStatus }}
              </div>
            </div>
            <div class="text-right">
              <div class="small text-secondary">
                {{ 'home.quote.validity' | cxTranslate }} {{a.quoteState == quoteStatusModel.offerReceived ? convertDate(a.offerValidity) : convertDate(a.quoteValidity)}}
              </div>
              <div *ngIf="a.quoteState == quoteStatusModel.offerReceived" class="text-danger small">
                {{expiryCalculate(a.offerValidity)}}
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap mt-4">
            <div class="small text-secondary mr-3">{{ 'home.quote.Id' | cxTranslate }} {{ a.c4cQuoteExternalQuoteId ? a.c4cQuoteExternalQuoteId : ' '}}</div>
            <div class="small text-secondary mr-3">{{ 'home.quote.Creationdate' | cxTranslate }} {{convertDateOnly(a.creationTime)}}</div>
            <div class="small text-secondary">{{'home.quote.BidPlacedBy' | cxTranslate }}: {{a.userName}}</div>
          </div>
        </div>
        <div class="hr"></div>
        <div class="inside-layout  align-self-stretch" *ngFor="let quote of a.quoteEntries">
            <div class="py-2">
            <div class="h5 mb-0 fw-bold">{{quote.productName | titlecase }}</div>
            <div class="h5 mb-0 text-secondary"> {{quote.portName}}</div>
            </div>
            <div class="row">
            <div class="col-6 col-md-auto">
              <div class="small text-secondary">{{ 'home.quote.Vesselname' | cxTranslate }}</div>
              <div class="strong"> {{ quote.vesselName}} </div>
            </div>
            <div class="col-6 col-md-auto">
              <div class="small text-secondary">{{ 'home.quote.Voyage' | cxTranslate }}</div>
              <div class="strong"> {{ quote.voyageId }} </div>
            </div>
            <div class="col-6 col-md-auto">
              <div class="small text-secondary">{{ 'home.quote.Price(perWMT)' | cxTranslate }} </div>
              <div class="strong"> {{ quote.price | currency: "RMB ":"symbol":"1.2-2" }} </div>
            </div>
            <div class="col-6 col-md-auto">
              <div class=" small text-secondary">{{ 'home.quote.Price(perWMT)' | cxTranslate }} </div>
              <div class="strong"> {{ quote.price | currency: "RMB ":"symbol":"1.2-2" }} </div>
              </div>
              <div class="col-6 col-md-auto">
              <div class="small text-secondary">{{ 'home.quote.Quantity(WMT)' | cxTranslate }}</div>
              <div class="strong"> {{ quote.quantity | number :"2.2-2" }} </div>
            </div>
            </div>
        </div>
        <div class="hr"></div>
        <div class="inside-layout  align-self-stretch pt-3 ">
          <!-- Desktop View -->
           <div class="d-none d-lg-block d-md-block">
            <div class="viewdetails "> 
              <a class="strong  text-primary " (click)="openDetailsQuote(a)">
                {{ 'home.quote.Viewdetails' | cxTranslate }} ></a>
            </div>
          </div>
            <div class="d-none d-lg-block d-md-block"> 
            <span *ngIf="a.quoteState == quoteStatusModel.bidPlaced">
              <button class="btn border pl-5 pr-5 w-100"
                [disabled]="isPlaceBidDisabled" (click)="openCancelModal(a,'bid')" [hidden]="a.quoteCode?false:true">
                {{ 'home.quote.Cancelbid' | cxTranslate }}
              </button>
            </span>
            <div class="desktop-flex">
              <div *ngIf="a.quoteState == quoteStatusModel.offerReceived">
                <button class="btn btn-primary btn-mobile-accept"
                  [disabled]="isAcceptOfferDisabled" (click)="openAcceptModal(a)">
                  <i class="fa fa-check text-white pr-2" aria-hidden="true"></i>
                  {{'home.quote.Acceptoffer' | cxTranslate }}
                </button>
              </div>
              <div class="justify-content-mobile-between d-flex ml-lg-1">
                <!-- <div *ngIf="a.quoteState == quoteStatusModel.offerReceived" class="mr-1 mobile-btn-counter">
                                      <button class="btn btn-secondary mobile-w-100  mobile-padding fw-bold" (click)="openCounterOfferModal(content2 , a)"><img class='pr-2'
                        src="/images/iconCounterOfferWhite.svg" alt=""><a class="anchor-tag text-white">{{
                        'home.quote.Counteroffer' | cxTranslate }}</a></button>
                                  </div> -->
                <div *ngIf="a.quoteState == quoteStatusModel.offerReceived" class='mobile-btn-reject'> <button
                   [disabled]="isPlaceBidDisabled" class=" btn btn-secondary left mobile-w-100 mobile-padding fw-bold"
                    (click)="openRejectModal(a)">
                    <i class="fas fa-times text-white pr-2"></i>
                    <a class="anchor-tag text-white ">{{ 'home.quote.Rejectoffer' | cxTranslate }}</a>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Mobile View -->
          <div class="d-lg-none">
            <span *ngIf="a.quoteState == quoteStatusModel.bidPlaced">
              <button class="btn border pl-5 pr-5 w-100 mb-3"
                [disabled]="isPlaceBidDisabled" (click)="openCancelModal(a,'bid')" [hidden]="a.quoteCode?false:true">
                {{ 'home.quote.Cancelbid' | cxTranslate }}
              </button>
            </span>
            <div class="desktop-flex mt-3">
              <div *ngIf="a.quoteState == quoteStatusModel.offerReceived">
                <button class="btn btn-primary btn-mobile-accept"
                  [disabled]="isAcceptOfferDisabled" (click)="openAcceptModal(a)">
                  <i class="fa fa-check text-white pr-2" aria-hidden="true"></i>
                  {{'home.quote.Acceptoffer' | cxTranslate }}
                </button>
              </div>
              <div *ngIf="a.quoteState == quoteStatusModel.offerReceived">
                  <button [disabled]="isPlaceBidDisabled" class="btn btn-secondary btn-mobile-accept"
                    (click)="openRejectModal(a)">
                    <i class="fas fa-times text-white pr-2"></i>
                    {{ 'home.quote.Rejectoffer' | cxTranslate }}
                  </button>
                  </div>
            </div>
            <div class="viewdetails">
              <a class="strong text-primary" (click)="openDetailsQuote(a)">
                {{ 'home.quote.Viewdetails' | cxTranslate }} ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
     <div><span class="h3 strong mb-4"
        *ngIf="!enableLoader && orders?.length>0">Orders</span>
    <!-- <div *ngIf="!enableLoader && (!orders || orders.length === 0)" class="text-secondary text-center bold">No orders found</div> -->
      <div class="card pt-3 pb-3 px-4 my-4 card-border border-radius-05" *ngFor="let a of orders; let i = index">
        <div class="d-flex justify-content-between">
          <div class='d-flex align-items-center'>
            <div class="bid-status-text p-1 badge badge-light" *ngIf="a.quoteStatus!=='Offer received'" [ngClass]="a.quoteStatus|quoteStatusStyle">{{
              a.quoteStatus }}</div>
               <div class="bid-status-text p-1 badge badge-primary" *ngIf="a.quoteStatus==='Offer received'" >{{
              a.quoteStatus }}</div>
            <!-- <div class="small text-secondary ml-3 visible-xs"
              *ngIf="activeTab === 'active' && a.quoteValidity != undefined "
              [ngClass]="a.quoteState == quoteStatusModel.offerReceived?'visible-lg':''"> {{ 'home.quote.validity' |
              cxTranslate }} {{a.quoteState ==
              quoteStatusModel.offerReceived?convertDate(a.offerValidity,a.offerValidityTimeZone):convertDate(a.quoteValidity,a.quoteValidityTimeZone)}}</div> -->
            <div *ngIf="a.quoteState == quoteStatusModel.offerReceived" class="ml-4 mt-0 text-danger  small">
              {{expiryCalculate(a.offerValidity)}}</div>
          </div>
          <div class='d-flex'>
            <span class="small text-secondary visible-xs mr-1">{{ 'home.quote.Id' | cxTranslate }} {{
              a.c4cQuoteExternalQuoteId ? a.c4cQuoteExternalQuoteId : ' '}}</span> &nbsp;
            <span class="small text-secondary visible-xs mr-3">
              {{ 'home.quote.Creationdate' | cxTranslate }} {{convertDateOnly(a.creationTime)}}
            </span>
            <span class="small text-secondary visible-xs">Order Placed by:
              {{a.userName}}</span>
          </div>
        </div>
        <div class="hr"></div>
        <div *ngFor="let quote of a.quoteEntries">
          <div class="row pb-3">
    <div class="col-md-3">
      <div class="h5 mb-0 fw-bold">
        {{quote?.productName| titlecase}}
      </div>
    </div>
    <div class="col-md-2">
      <div class="text-secondary">
        Quantity (ST)
      </div>
        <div class="strong" *ngIf="a?.allowedDecimalQty==0">
        {{quote?.quantityInDecimal|number:'1.0-0'}}
      </div>
      <div class="strong" *ngIf="a?.allowedDecimalQty>0">
        {{quote?.quantityInDecimal|number:'1.3-3'}}
      </div>
  
    </div>
    <div class="col-md-1">
      <div class="text-secondary">
        Base price
      </div>
      <div class="strong">
        {{quote?.basePriceValue }}
      </div>
  
    </div>
    <div class="col-md-2">
      <div class="text-secondary">
        Order Date
      </div>
      <div class="strong">
        {{quote?.deliveryStartDate | date:'dd/MM/yyyy'}}
      </div>
  
    </div>
      <div class="col-md-2">
      <div class="text-secondary">
       External reference no
      </div>
      <div class="strong">
        {{a?.externalRefNo ? a?.externalRefNo : '--'}}
      </div>
    </div>
        <div class="col-md-2">
      <div class="text-secondary">
        Location
      </div>
      <div class="strong" >
               {{quote?.locationName }} {{a.address.houseNum}}
                    {{a.address?.street}} {{a.address?.city}}
                    / {{a.address?.state}}
                    {{a.address?.country}} {{a.address?.pin}}

      </div>
      </div>
    </div>
  <div class="row">
    <ng-container *ngFor="let price of quote?.priceList">
    <div  class="col-md-2 col pb-3" *ngIf="price.kopCode!=='BASE'">
        <div class="small text-secondary">{{ price.kopName }}</div>
        <div class="strong" *ngIf="!price.kopPricePercentage||price.kopPricePercentage==0">
          ${{price.kopPriceAmount|number:'1.2-2'}}
          </div>
          <div class="strong" *ngIf="price.kopPricePercentage && price.kopPricePercentage!=0">
          {{price.kopPricePercentage|number:'1.2-2'}}%
          </div>
    </div>
  </ng-container>
  </div>
        </div>
        <div class="hr"></div>
        <div class=" row">
          <div class="viewdetails col-md-3">
            <a class="strong  text-primary " (click)="openDetailsQuote(a)">
              {{ 'home.quote.Viewdetails' | cxTranslate }} ></a>
          </div>
          <div [ngClass]="a.quoteState == quoteStatusModel.offerReceived ? 'col-md-5' : 'col-md-7'"></div>
          <!-- <div class="col-md-2" *ngIf="a.quoteState == quoteStatusModel.bidPlaced && a.c4cQuoteExternalQuoteId">
            <span> <button class="btn border pl-5 pr-5  w-100 "
                [disabled]="isPlaceBidDisabled" (click)="editOrder(a)" [hidden]="a.quoteCode?false:true">
                Edit order</button></span>
          </div> -->
          <div class="col-md-2" *ngIf="a.quoteState == quoteStatusModel.bidPlaced && a.c4cQuoteExternalQuoteId">
            <span > <button class="btn border pl-5 pr-5  w-100 "
                [disabled]="isPlaceBidDisabled" (click)="openCancelModal(a,'order')" [hidden]="a.quoteCode?false:true">
                Cancel order</button></span>
          </div>
            <div class="col-md-2" *ngIf="a.quoteState == quoteStatusModel.offerReceived">
              <button class="btn btn-primary btn-mobile-accept w-100"
                [disabled]="isAcceptOfferDisabled" (click)="openAcceptModal(a)"> <i class="fa fa-check text-white pr-2"
                  aria-hidden="true"></i>
                {{'home.quote.Acceptoffer' | cxTranslate }} </button>
            </div>
            <div class="col-md-2" *ngIf="a.quoteState == quoteStatusModel.offerReceived">
              <button [disabled]="isPlaceBidDisabled" class=" btn btn-secondary w-100 fw-bold" (click)="openRejectModal(a)">
                <i class="fas fa-times text-white pr-2"></i>{{
                'home.quote.Rejectoffer' | cxTranslate }}</button>
            </div>
          
        
        </div>
      </div>
    </div>
    <!-- ---modal--- -->
    <app-accept-bid-modal #acceptModal>
    </app-accept-bid-modal>
    <!-- <app-cancel-bid-modal [from]="fromScreen" #cancelModal>
    </app-cancel-bid-modal> -->
    <app-counter-offer-modal #counterOfferModal [modalConfig]="modalConfig" [focus]="modalfocus">
    </app-counter-offer-modal>
    <app-reject-bid-modal #rejectModal>
    </app-reject-bid-modal>